var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "movements-page" } }, [
    _c("div", { staticClass: "page-header" }, [
      _c("div", { staticClass: "header-left" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "header-info" }, [
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("whatsapp_business_api.wabaMovementsTitle"))),
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("whatsapp_business_api.wabaMovementsSubtitle"))
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "header-right" }, [
        _vm.pagination.total > 0
          ? _c("div", { staticClass: "activity-count" }, [
              _c("span", { staticClass: "count" }, [
                _vm._v(_vm._s(_vm.pagination.total)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "label" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t("whatsapp_business_api.wabaMovementsTotalActivity")
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "refresh-btn",
            attrs: { disabled: _vm.loading },
            on: { click: _vm.refreshActivities },
          },
          [
            _c(
              "span",
              {
                staticClass: "material-icons",
                class: { spinning: _vm.loading },
              },
              [_vm._v("refresh")]
            ),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "notification-settings",
        class: { collapsed: !_vm.settingsExpanded },
      },
      [
        _c(
          "div",
          {
            staticClass: "settings-header",
            on: {
              click: function ($event) {
                _vm.settingsExpanded = !_vm.settingsExpanded
              },
            },
          },
          [
            _c("div", { staticClass: "header-left" }, [
              _c("span", { staticClass: "material-icons header-icon" }, [
                _vm._v("notifications"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "header-title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "whatsapp_business_api.wabaMovementsEmailNotifications"
                    )
                  )
                ),
              ]),
              _vm._v(" "),
              _c(
                "span",
                {
                  staticClass: "status-badge",
                  class: { active: _vm.notificationsEnabled },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.notificationsEnabled
                          ? _vm.$t("whatsapp_business_api.wabaMovementsActive")
                          : _vm.$t("whatsapp_business_api.wabaMovementsOff")
                      ) +
                      "\n                "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "material-icons expand-icon",
                class: { expanded: _vm.settingsExpanded },
              },
              [_vm._v("expand_more")]
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.settingsExpanded,
                expression: "settingsExpanded",
              },
            ],
            staticClass: "settings-content",
          },
          [
            _c(
              "div",
              { staticClass: "setting-item" },
              [
                _c("div", { staticClass: "setting-info" }, [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("email"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "setting-text" }, [
                    _c("span", { staticClass: "setting-title" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.wabaMovementsEmailSettingTitle"
                          )
                        )
                      ),
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "setting-desc" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.wabaMovementsEmailSettingDesc"
                          )
                        )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("a-switch", {
                  attrs: {
                    checked: _vm.notificationsEnabled,
                    loading: _vm.updateLoading,
                  },
                  on: { change: _vm.toggleNotifications },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.notificationsEnabled
              ? _c("div", { staticClass: "email-management" }, [
                  _c("div", { staticClass: "email-header" }, [
                    _c("span", { staticClass: "material-icons" }, [
                      _vm._v("people"),
                    ]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "whatsapp_business_api.wabaMovementsEmailListHeader"
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "email-input-wrapper" },
                    [
                      _c("a-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "whatsapp_business_api.wabaMovementsEmailPlaceholder"
                          ),
                          disabled: _vm.updateLoading,
                        },
                        on: { pressEnter: _vm.addEmail },
                        model: {
                          value: _vm.newEmail,
                          callback: function ($$v) {
                            _vm.newEmail = $$v
                          },
                          expression: "newEmail",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "a-button",
                        {
                          attrs: {
                            type: "primary",
                            disabled: !_vm.isValidEmail || _vm.updateLoading,
                          },
                          on: { click: _vm.addEmail },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("add"),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "email-tags" },
                    [
                      _vm._l(_vm.notificationEmails, function (email) {
                        return _c(
                          "a-tag",
                          {
                            key: email,
                            attrs: { closable: "" },
                            on: {
                              close: function ($event) {
                                return _vm.removeEmail(email)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(email) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      _vm._v(" "),
                      _vm.notificationEmails.length === 0
                        ? _c("span", { staticClass: "no-emails" }, [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t(
                                    "whatsapp_business_api.wabaMovementsNoEmailsYet"
                                  )
                                ) +
                                "\n                    "
                            ),
                          ])
                        : _vm._e(),
                    ],
                    2
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "page-content" },
      [
        _c("WabaActivityListView", {
          attrs: {
            activities: _vm.activities,
            loading: _vm.loading,
            hasMore: _vm.pagination.hasNextPage,
          },
          on: { "load-more": _vm.loadMore },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-icon" }, [
      _c("span", { staticClass: "material-icons" }, [_vm._v("history")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }